import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filial-item',
  templateUrl: './filial-item.component.html',
  styleUrls: ['./filial-item.component.css']
})
export class FilialItemComponent implements OnInit {

  @Input() filial: any;
  @Input() currentUser: any;
  @Output('onDelete') deleteFilial = new EventEmitter(); 

  detailsRouterLink: any;
  editRouterLink: any;
  adminsRouterLink: any;


  constructor(
    public router: Router,
  ) { }

  ngOnInit(): void {
    if(this.router.url.includes('/root/filials')) {
      this.detailsRouterLink = ['/root','companies',this.filial.companyId, 'filials', this.filial.id, 'inventars'];
      this.editRouterLink= ['/root','companies',this.filial.companyId, 'filials', this.filial.id, 'edit'];
      this.adminsRouterLink= ['/root','companies',this.filial.companyId, 'filials', this.filial.id, 'admins'];
    } else {
      this.detailsRouterLink = [this.filial.id, 'inventars'];
      this.editRouterLink= [this.filial.id, 'edit'];
      this.adminsRouterLink= [this.filial.id, 'admins'];
    }
  }

  onDelete(filial) {
    this.deleteFilial.emit(filial);
  }

}
